import { render } from "./NewDashboardLayout.vue?vue&type=template&id=7de0c864"
import script from "./NewDashboardLayout.vue?vue&type=script&lang=js"
export * from "./NewDashboardLayout.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/origins-userdash-v2/origins-userdash-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__